export interface AddressDetails {
  country?: string;
  unit?: string;
  street_address?: string;
  suburb?: string;
  city?: string;
  province?: string;
  postal_code?: string;
}

export const initialAddressDetails: AddressDetails = {
  country: 'ZA',
  unit: '',
  street_address: '',
  suburb: '',
  city: '',
  province: '',
  postal_code: '',
};
